<template>
  <div v-if="carrier" class="d-flex align-items-center p-0 carrier-icon-wrap">
    <img :src="logoHandle" alt="carrier" />
    <span v-if="!onlyIcon" class="tooltip-text ml-2">
      {{ carrierHandler2Name(carrier) }}
    </span>
    <span v-if="suffix" class="tooltip-text ml-2">
      {{ suffix }}
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { ASENDIA, BRING, CITYMAIL, DEUTSCHEPOST, DHL_EXPRESS, DHL_FREIGHT, EARLYBIRD, LETTER_CARRIER, POSTI, POSTNORD, UPS, CARRIERS } from '@/const/Carriers'
import { carrierHandler2Name } from '@/services/Helpers'
import upsLogo from '@/assets/img/carriers/ups.png'
import bringLogo from '@/assets/img/carriers/bring.png'
import postiLogo from '@/assets/img/posti-logo.svg'
import asendiaLogo from '@/assets/img/asendia-logo.svg'
import citymailLogo from '@/assets/img/citymail-logo.svg'
import postnordLogo from '@/assets/img/postnord-logo.svg'
import earlybirdLogo from '@/assets/img/earlybird-logo.svg'
import dhlExpressLogo from '@/assets/img/dhl_express-logo.svg'
import dhlFreightLogo from '@/assets/img/dhl_freight-logo.svg'
import deutschepostLogo from '@/assets/img/deutschepost-logo.svg'
import letterCarrierLogo from '@/assets/img/letter_carrier-logo.svg'

export default defineComponent({
  name: 'CarrierRowWithIcon',
  props: {
    carrier: {
      type: String,
      default: '',
      validator: (value: string) => Object.values(CARRIERS).indexOf(value) !== -1,
    },
    onlyIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    suffix: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const carrierLogos: Record<string, string> = {
      [ASENDIA]: asendiaLogo,
      [CITYMAIL]: citymailLogo,
      [DEUTSCHEPOST]: deutschepostLogo,
      [DHL_EXPRESS]: dhlExpressLogo,
      [DHL_FREIGHT]: dhlFreightLogo,
      [EARLYBIRD]: earlybirdLogo,
      [LETTER_CARRIER]: letterCarrierLogo,
      [POSTI]: postiLogo,
      [POSTNORD]: postnordLogo,
      [BRING]: bringLogo,
      [UPS]: upsLogo,
    }

    const logoHandle = computed(() => carrierLogos[props.carrier] || '')

    return {
      logoHandle,
      carrierHandler2Name,
    }
  },
})
</script>
